import Header from "components/header"
import { Route as DOMRoute } from "react-router-dom"
import Login from "pages/login"
import { useDispatch, useSelector } from "react-redux"
import { actions } from "redux/reducers"
import api from "api"

function Route({ showHeader = true, validateToken = true, ...props }) {
  const user = useSelector((state: any) => state.user)
  const dispatch = useDispatch()

  if (!user && validateToken) {
    if (!localStorage.AccessToken) {
      return <DOMRoute component={Login} path={props.path} />
    } else {
      api.user.get().then((data) => {
        dispatch(actions.user.set(data))
      })
      api.clients.getAll().then((data) => {
        dispatch(actions.clients.set(data))
      })
      return (
        <DOMRoute path={props.path} exact={props.exact}>
          {showHeader && <Header />}
          {props.children}
        </DOMRoute>
      )
    }
  } else {
    return (
      <DOMRoute path={props.path} exact={props.exact}>
        {showHeader && <Header />}
        {props.children}
      </DOMRoute>
    )
  }
}

export default Route
